import { inject, Pipe, PipeTransform } from '@angular/core';
import { NO_DATA } from '@cf/core';
import { TranslateService } from '@tolgee/ngx';
import { DateTime } from 'luxon';

@Pipe({ name: 'dateFormat', pure: false })
export class DateFormatPipe implements PipeTransform {
  translateService = inject(TranslateService);
  prevLang = '';
  prevValue = '';
  result = '';

  transform(value: string | undefined, format = 'DD', setZone = false): string {
    if (!value) {
      return NO_DATA;
    }
    const lang = this.translateService.language;
    if (this.prevLang === lang && this.prevValue === value) {
      return this.result;
    }

    this.prevLang = lang;
    this.prevValue = value;

    this.result = DateTime.fromISO(value, { setZone }).setLocale(lang).toFormat(format);
    return this.result;
  }
}
